import React from "react";
import { useSelector } from "react-redux";

export default () => {
  const currentActivity = useSelector((state) => state.activity);
  return (
    <div className="header-content mt-9 pb-9 pt-90">
      <div className="container">
        <div className="row text-center">
          <div className="col-md-10 col-md-offset-1">
            <div className="header-texts">
              <h1
                className="wow fadeInUp"
                // style={{
                //   color: "#313e48",
                // }}
                data-wow-duration=".5s"
              >
                {`${
                  currentActivity &&
                  currentActivity.websiteData &&
                  currentActivity.websiteData.aboutClient &&
                  currentActivity.websiteData.aboutClient.data &&
                  currentActivity.websiteData.aboutClient.data.name
                    ? currentActivity.websiteData.aboutClient.data.name
                    : "--"
                }`}
              </h1>

              <h3
                className="wow fadeInUp heading-light"
                // style={{
                //   color: "#313e48",
                // }}
              >
                présente :
              </h3>

              <h2
                className="wow fadeInUp heading-light"
                // style={{
                //   color: "#638b18",
                // }}
              >
                {`${
                  currentActivity && currentActivity.name
                    ? currentActivity.name
                    : "--"
                }`}
              </h2>
              <div className="mb-30">
                <img
                  src={`${
                    currentActivity && currentActivity.logo
                      ? currentActivity.logo
                      : "--"
                  }`}
                  alt="logo event"
                  style={{ height: "130", marginTop: "35px", maxWidth: "40%" }}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="row text-center">
          <div className="col-md-10 col-md-offset-1"></div>
        </div>
      </div>
    </div>
  );
};
